module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-6.1cc858a6.svg";